<div class="row row--primary">
  <bezugsrecht-back-link (back)="back()" label="bezugsrecht-page.bezugsrecht-summary.link-back" />
  <ng-container *ngIf="model?.directivePreview">
    <div class="tile">
      <div class="col-12 mt-2 opacity-container" [class.active]="model.directivePreview">
        <div class="row mb-2">
          <div class="col-12 mb-4">
            <h5
              [innerHTML]="
                'bezugsrecht-page.bezugsrecht-summary.title'
                  | transloco
                    : {
                        name: model.directivePreview.bzrBezeichnung,
                        isin: model.directivePreview.bzrIsin,
                      }
              "
            >
              &nbsp;
            </h5>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-sm-8">{{ 'bezugsrecht-page.bezugsrecht-summary.amount-shares' | transloco }}</div>
          <div class="col-sm-4 font-bold text-right">
            <ng-container *ngIf="model.directivePreview.bezugAktien; else novalue">{{
              model.directivePreview.bezugAktien | number: '1.0-3'
            }}</ng-container>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-sm-8">{{ 'bezugsrecht-page.bezugsrecht-summary.rights-need' | transloco }}</div>
          <div class="col-sm-4 font-bold text-right">
            <ng-container *ngIf="model.directivePreview.benoetigteBzr; else novalue">{{
              model.directivePreview.benoetigteBzr | number: '1.0-3'
            }}</ng-container>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-sm-8">{{ 'bezugsrecht-page.bezugsrecht-summary.rights-portfolio' | transloco }}</div>
          <div class="col-sm-4 font-bold text-right">{{ model.directivePreview.verfuegbareBzr | number: '1.0-3' }}</div>
        </div>
        <div class="row mt-3">
          <ng-container *ngIf="model.directivePreview.bezugBzr; else sellBzr">
            <div class="col-sm-8">{{ 'bezugsrecht-page.bezugsrecht-summary.rights-buy' | transloco }}</div>
            <div class="col-sm-4 font-bold text-right">
              <ng-container *ngIf="model.directivePreview.bezugBzr; else novalue">{{
                model.directivePreview.bezugBzr | number: '1.0-3'
              }}</ng-container>
            </div>
            <ng-container *ngIf="model.directivePreview.bzrHandelbarBroker; else externalExchangeHint">
              <div class="col-sm-12 mt-0 mb-2 font-size-smaller2">
                {{ 'bezugsrecht-page.bezugsrecht-summary.rights-buy-hint' | transloco }}
              </div>
            </ng-container>
            <div class="col-sm-8">{{ 'bezugsrecht-page.bezugsrecht-summary.rights-value' | transloco }}</div>
            <div class="col-sm-4 font-bold text-right">
              <ng-container *ngIf="model.directivePreview.bezugBzrWertSumme; else novalue">{{
                model.directivePreview.bezugBzrWertSumme | currency: 'EUR' : 'symbol' : '1.2'
              }}</ng-container>
              <ng-container *ngIf="model.directivePreview.bzrPreisZeitpunkt">
                <div class="font-size-smaller2">({{ model.directivePreview.bzrPreisZeitpunkt | todayTimeOrDate }})</div>
              </ng-container>
              <div
                class="text-right mt-1 font-size-smaller2"
                [innerHtml]="
                  'bezugsrecht-page.bezugsrecht-summary.buying-power-hint'
                    | transloco
                      : {
                          buyingPower: model.buyingPower | currency: 'EUR' : 'symbol' : '1.2',
                        }
                "
              ></div>
            </div>
            <ng-container *ngIf="model.buyingPower && model.buyingPower < model.directivePreview.bezugBzrWertSumme">
              <div class="col-sm-12 text-right text-danger font-size-smaller2">
                {{ 'bezugsrecht-page.bezugsrecht-summary.bp-too-low-hint' | transloco }}
              </div>
            </ng-container>
          </ng-container>
          <ng-template #sellBzr>
            <div class="col-sm-8">{{ 'bezugsrecht-page.bezugsrecht-summary.rights-sell' | transloco }}</div>
            <div class="col-sm-4 font-bold text-right">
              <ng-container *ngIf="model.directivePreview.verkaufBzr; else novalue">{{
                model.directivePreview.verkaufBzr | number: '1.0-3'
              }}</ng-container>
            </div>
            <ng-container *ngIf="model.directivePreview.bzrHandelbarBroker; else externalExchangeHint">
              <div class="col-sm-12 mt-0 mb-2 font-size-smaller2">
                {{ 'bezugsrecht-page.bezugsrecht-summary.rights-sell-hint' | transloco }}
              </div>
            </ng-container>
            <div class="col-sm-8">{{ 'bezugsrecht-page.bezugsrecht-summary.rights-value' | transloco }}</div>
            <div class="col-sm-4 font-bold text-right">
              <ng-container *ngIf="model.directivePreview.verkaufBzrWertSumme; else novalue">{{
                model.directivePreview.verkaufBzrWertSumme | currency: 'EUR' : 'symbol' : '1.2'
              }}</ng-container>
              <ng-container *ngIf="model.directivePreview.bzrPreisZeitpunkt && model.directivePreview.verkaufBzrWertSumme">
                <div class="font-size-smaller2">({{ model.directivePreview.bzrPreisZeitpunkt | todayTimeOrDate }})</div>
              </ng-container>
            </div>
          </ng-template>
          <ng-container *ngIf="showLowTrading$ | async">
            <div class="col-sm-8" [innerHTML]="'bezugsrecht-page.bezugsrecht-summary.lowtrading' | transloco"></div>
            <div class="col-sm-4 font-bold text-right">
              {{ minimumQuantitySurcharge | currency: 'EUR' : 'symbol' : '1.2' }}
            </div>
            <ng-container *ngIf="showDisproportionateFeesHint$ | async">
              <div class="col-12 text-center font-size-smaller2">
                {{ 'bezugsrecht-page.bezugsrecht-summary.disproportionate-fees-hint' | transloco }}
              </div>
            </ng-container>
          </ng-container>
        </div>
        <div class="row mt-3">
          <div class="col-sm-8">{{ 'bezugsrecht-page.bezugsrecht-summary.share-price' | transloco }}</div>
          <div class="col-sm-4 font-bold text-right">
            <ng-container *ngIf="model.directivePreview.bezugAktienWertSumme; else novalue">{{
              model.directivePreview.bezugAktienWertSumme | currency: 'EUR' : 'symbol' : '1.2'
            }}</ng-container>
          </div>
        </div>
        <div class="row mt-3 mb-4">
          <div class="col-sm-8">{{ 'bezugsrecht-page.bezugsrecht-summary.due-date' | transloco }}</div>
          <div class="col-sm-4 font-bold text-right">{{ model.directivePreview.bezugAktienTermin | date: 'shortDate' }}</div>
        </div>

        @if (showWarning && !warningAccepted) {
          <div class="alert alert-primary" role="alert">
            <div class="font-medium mb-2">
              {{ 'trade.create.check-experience-and-ftg.showExperienceNoticeKrypto.headline' | transloco }}
            </div>
            <div class="row">
              <div class="col-12 mb-4">
                {{
                  'bezugsrecht-page.bezugsrecht-summary.warning'
                    | transloco
                      : {
                          calculationWarningValue: calculationWarningValue | currency: 'EUR' : 'symbol' : '1.2',
                          valutatag: valutatag | date: 'shortDate',
                        }
                }}
              </div>
              <div
                class="col-12 col-sm-6 d-flex pt-2 pt-sm-0 order-1 order-sm-0 justify-content-center justify-content-sm-start align-items-center"
              >
                <a class="link link-secondary cursor-pointer" (click)="cancelWarning()">
                  {{ 'trade.create.check-experience-and-ftg.showExperienceNoticeKrypto.cancel' | transloco }}
                </a>
              </div>
              <div class="col-12 col-sm-6 d-flex justify-content-end pt-2 pt-sm-0 order-0 order-sm-1">
                <web-design-system-button size="small" (click)="acceptWarning()">
                  {{ 'trade.create.check-experience-and-ftg.showExperienceNoticeKrypto.proceed' | transloco }}
                </web-design-system-button>
              </div>
            </div>
          </div>
        }

        <web-components-trading-session (authorizationState)="sessionAuthState($event)" />

        <div class="row mt-3">
          @if (showLowTradingHint$ | async) {
            <div
              class="col-sm-12 text-center"
              [innerHTML]="
                'bezugsrecht-page.bezugsrecht-summary.lowtrading-hint'
                  | transloco
                    : {
                        lowTradingThreshold: lowTradingThreshold,
                        minQuantitySurcharge: minimumQuantitySurcharge,
                      }
              "
            ></div>
            <div class="col-sm-12 d-flex justify-content-center mt-3">
              <web-design-system-button
                size="small"
                (click)="clicked = true; confirmLowTradingAndPlaceDirective()"
                [disabled]="clicked || !sessionAuthorized || (showWarning && !warningAccepted)"
              >
                {{ 'bezugsrecht-page.bezugsrecht-summary.link-submit-buy-lowtrading' | transloco }}
              </web-design-system-button>
            </div>
          } @else {
            <div class="col-sm-12 d-flex justify-content-center">
              <web-design-system-button
                (click)="clicked = true; placeDirective()"
                size="small"
                [disabled]="clicked || !sessionAuthorized || (showWarning && !warningAccepted)"
              >
                <span
                  [innerHTML]="
                    (model.directivePreview.bezugBzr
                      ? ('bezugsrecht-page.bezugsrecht-summary.link-submit-buy' | transloco)
                      : model.directivePreview.verkaufBzr
                        ? ('bezugsrecht-page.bezugsrecht-summary.link-submit-sell' | transloco)
                        : ('bezugsrecht-page.bezugsrecht-summary.link-submit' | transloco)
                    ) | uppercase
                  "
                ></span
              ></web-design-system-button>
            </div>
          }
        </div>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #novalue>&mdash;</ng-template>

<ng-template #externalExchangeHint>
  <ng-container *ngIf="showExternalExchangeHint; else spacer">
    <div
      class="col-sm-12 mt-0 mb-2 text-center font-size-smaller2"
      [innerHTML]="'bezugsrecht-page.bezugsrecht-summary.external-exchange-hint' | transloco"
    ></div>
  </ng-container>
  <ng-template #spacer><div class="col-sm-12 mt-3"></div></ng-template>
</ng-template>
